export default __webpack_public_path__ + "static/media/151-beds.c01c1423.png";